import { makeStyles } from "@material-ui/core";

export const vehicleGradeCardStyle = makeStyles(theme => ({
    card: {
        margin: '0.5em 0',
        padding: '1.5em 2em',
        border: `2px dashed ${theme.palette.primary.main}`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '150px',
    },
    label: {
        fontSize: '0.75em',
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        color: theme.palette.primary.main,
        marginBottom: '0.25em',
    },
    gradeNumber: {
        fontSize: '3em',
        fontWeight: 700,
        lineHeight: 1,
        color: theme.typography.color,
        marginBottom: '0.2em',
    },
    starsRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '2px',
        marginBottom: '0.25em',
        '& svg': {
            color: theme.palette.primary.main,
            fontSize: '1.4em',
        },
    },
    outOf: {
        fontSize: '0.75em',
        color: theme.palette.text.secondary,
    },
    pendingText: {
        fontSize: '0.85em',
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
}));
